import { push as pushLocation } from "react-router-redux";
import { backToFront, frontToBack } from "./dataConversion";
import { fieldErrorsBackToFront } from "./../misc/dataConversion";
import ProfileRepository from "./ProfileRepository";
import { AUTH_ACTIONS } from "../auth/authActions";
export const PROFILE_ACTIONS = {
    PROFILE_CREATE_STARTED: "profile-create-started",
    PROFILE_CREATE_FAILED: "profile-create-failed",
    PROFILE_CREATE_SUCCEEDED_FALSE: "profile-create-succeeded-false",
    PROFILE_CREATE_SUCCEEDED_TRUE: "profile-create-succeeded-true",
    PROFILE_UPDATE_STARTED: "profile-update-started",
    PROFILE_UPDATE_FAILED: "profile-update-failed",
    PROFILE_UPDATE_SUCCEEDED_FALSE: "profile-update-succeeded-false",
    PROFILE_UPDATE_SUCCEEDED_TRUE: "profile-update-succeeded-true",
    PROFILE_RETRIEVED: "profile-retrieved",
    DELETE_BANK_STARTED: "delete-bank-started",
    DELETE_BANK_FAILED: "delete-bank-failed",
    DELETE_BANK_SUCCEEDED: "delete-bank-succeeded"
};
/**
 * Uses form data to create profile, dispatching appropriate actions
 *
 * @method createProfile
 * @param {String} profile Value of profile form
 * @returns {Function} Redux thunk
 */
export const createProfile = (profile) => async (dispatch) => {
    dispatch({ type: PROFILE_ACTIONS.PROFILE_CREATE_STARTED });
    let profileResponse;
    try {
        const mappedProfile = frontToBack(profile);
        profileResponse = await ProfileRepository.createProfile(mappedProfile);
    }
    catch (error) {
        dispatch({ type: PROFILE_ACTIONS.PROFILE_CREATE_FAILED, payload: error });
        if (error.response.status === 401) {
            dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
            dispatch(pushLocation("/public"));
        }
        return;
    }
    if (!profileResponse.success) {
        const preparedErrors = fieldErrorsBackToFront(profileResponse.errors);
        dispatch({
            type: PROFILE_ACTIONS.PROFILE_CREATE_SUCCEEDED_FALSE,
            payload: preparedErrors
        });
    }
    else {
        const mappedData = backToFront(profileResponse.data);
        dispatch({
            type: PROFILE_ACTIONS.PROFILE_CREATE_SUCCEEDED_TRUE,
            payload: mappedData
        });
        dispatch(pushLocation("/secured"));
    }
};
/**
 * Uses form data to update profile, dispatching appropriate actions
 *
 * @method updateProfile
 * @param {Object} profile Value of profile form
 * @returns {Function} Redux thunk
 */
export const updateProfile = (profile) => async (dispatch) => {
    dispatch({ type: PROFILE_ACTIONS.PROFILE_UPDATE_STARTED });
    let response;
    try {
        const mappedProfile = frontToBack(profile);
        response = await ProfileRepository.updatedProfile(mappedProfile);
    }
    catch (error) {
        dispatch({ type: PROFILE_ACTIONS.PROFILE_CREATE_FAILED, payload: error });
        if (error.response.status === 401) {
            dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
            dispatch(pushLocation("/public"));
        }
        return;
    }
    if (!response.success) {
        const preparedErrors = fieldErrorsBackToFront(response.errors);
        dispatch({
            type: PROFILE_ACTIONS.PROFILE_UPDATE_SUCCEEDED_FALSE,
            payload: preparedErrors
        });
    }
    else {
        dispatch({
            type: PROFILE_ACTIONS.PROFILE_UPDATE_SUCCEEDED_TRUE,
            payload: {
                data: response,
                profile: backToFront(response.data)
            }
        });
    }
};
/**
 * Gets profile information from the API, dispatching appropriate actions
 *
 * @method retrieveProfile
 * @returns {Function} Redux thunk
 */
export const retrieveProfile = () => async (dispatch) => {
    let response;
    try {
        response = await ProfileRepository.getProfile();
        if (!response.success) {
            throw new Error("Unexpected response");
        }
    }
    catch (error) {
        return { success: false, error };
    }
    const mappedProfile = backToFront(response.data);
    dispatch({
        type: PROFILE_ACTIONS.PROFILE_RETRIEVED,
        payload: mappedProfile
    });
    return {
        success: true,
        error: null
    };
};
export const deleteBank = (id) => async (dispatch) => {
    dispatch({ type: PROFILE_ACTIONS.DELETE_BANK_STARTED });
    try {
        await ProfileRepository.deleteBank(id);
    }
    catch (error) {
        dispatch({
            type: PROFILE_ACTIONS.DELETE_BANK_FAILED,
            payload: error
        });
        if (error.response.status === 401) {
            dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
            dispatch(pushLocation("/public"));
        }
        return;
    }
    dispatch({
        type: PROFILE_ACTIONS.DELETE_BANK_SUCCEEDED,
        payload: id
    });
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/profile/profileActions.ts